import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

// Suppress noisy ResizeObserver loop errors that occur when new nodes are
// created. These errors originate from the browser and are harmless but they
// trigger the development overlay. Installing the handler here ensures it runs
// before React is mounted.
if (process.env.NODE_ENV === 'development') {
  const handleObserverErrors = (event) => {
    if (event.message && event.message.includes('ResizeObserver')) {
      event.stopImmediatePropagation();
    }
  };
  window.addEventListener('error', handleObserverErrors);
  window.addEventListener('unhandledrejection', handleObserverErrors);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
